export default __webpack_public_path__ + "static/3-ec327fbdb94fd04504d5a1ce472d92df.webp";